















import { TownModel } from '@/libs/Api';
import { CrudGetter } from '@/libs/core/+state/models/crud-getter';
import { townsStore } from '@/libs/towns/+state/store';
import { Component, Prop, VModel, Vue, Watch } from 'vue-property-decorator';

@Component({ })
export default class TownSelect extends Vue {

    items: TownModel[] = [];

    @Prop({ default: "" }) label!: string;
    @VModel() innerValue!: string;
    @Prop() readonly!: boolean;
    @Prop() rules!: [ any[] ];
    @Prop({ default: false }) required!: boolean;
    @Prop() districtId!: string | null;
    @Prop() placeholder!: string;

    @Watch("districtId")
    districtIdChanged () {
        this.loadTowns();
    }
    
    @Watch("innerValue")
    innerValueChanged (v: string) {
        if (v != null && !this.items.find((x: TownModel) => { return x.id == v; })) {
            this.$emit("input", null);
        }
        this.$emit("change", v);
    }

    mounted () {
        this.loadTowns();
    }

    loadTowns () {
        this.items = townsStore.useGetter(CrudGetter.Data)?.filter((e: TownModel) => {
            return e.districtId == this.districtId;
        })
    }

}
